import * as React from 'react';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import ResultsPage from '../../pages/ResultsPage';
import ImagePage from '../../pages/ImagePage';
import InfoPage from '../../pages/InfoPage';
import IndiGrainResultsPage from '../../pages/IndiGrainResultsPage';
import ReadingsPage from '../../pages/ReadingsPage';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import { getText } from 'src/utils/i18n';
import { useSelector } from 'react-redux';
import { IStore } from 'src/redux/reducers';
import { useResponsive } from 'src/hooks/useResponsive';

const Tab = createMaterialTopTabNavigator();
export default function HomeTabs({ navigation, route }) {
    const colorMode = useSelector((store: IStore) => store.settings.colorMode);
    const { isLargeScreen } = useResponsive();

    return (
        <Tab.Navigator
            screenOptions={() => ({
                tabBarActiveTintColor: colorMode === 'dark' ? 'white' : 'black',
                tabBarInactiveTintColor: colorMode === 'dark' ? 'lightgray' : 'gray',
                tabBarLabelStyle: { 
                    fontSize: isLargeScreen ? 12 : 8,
                    fontWeight: '600',
                },
                tabBarStyle: {
                    backgroundColor: colorMode === 'dark' ? '#171717' : 'white',
                    borderBottomWidth: colorMode === 'light' && isLargeScreen ? 1 : 0,
                    borderBottomColor: '#e2e8f0',
                    elevation: isLargeScreen ? 0 : 4,
                    shadowOpacity: isLargeScreen ? 0 : 0.1,
                },
                tabBarIndicatorStyle: {
                    backgroundColor: colorMode === 'dark' ? 'white' : 'black',
                    height: 3,
                },
                tabBarPressColor: colorMode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
            })}>
            <Tab.Screen name="Info"
                component={InfoPage}
                initialParams={route?.params}
                options={{
                    tabBarLabel: getText('info') ,
                    tabBarIcon: ({ color }) => (
                        <MaterialCommunityIcons name="information" color={color} size={isLargeScreen ? 26 : 24} />
                    ),
                }} />
            <Tab.Screen
                name="Image"
                component={ImagePage}
                initialParams={route?.params}
                options={{
                    tabBarLabel: getText('image'),
                    tabBarIcon: ({ color }) => (
                        <MaterialCommunityIcons name="image" color={color} size={isLargeScreen ? 26 : 24} />
                    ),
                }} />
            <Tab.Screen
                name="Indi Grains"
                component={IndiGrainResultsPage}
                initialParams={route?.params}
                options={{
                    tabBarLabel: getText('readings'),
                    tabBarIcon: ({ color }) => (
                        <MaterialCommunityIcons name="table-large" color={color} size={isLargeScreen ? 26 : 24} />
                    ),
                }} />
            <Tab.Screen
                name="Analysis"
                component={ResultsPage}
                initialParams={route?.params}
                options={{
                    tabBarLabel: getText('analysis'),
                    tabBarIcon: ({ color }) => (
                        <MaterialCommunityIcons name="view-quilt-outline" color={color} size={isLargeScreen ? 26 : 24} />
                    ),
                }} />
            <Tab.Screen
                name="History"
                component={ReadingsPage}
                initialParams={route?.params}
                options={{
                    tabBarLabel: getText('history'),
                    tabBarIcon: ({ color }) => (
                        <MaterialCommunityIcons name="clipboard-text-clock" color={color} size={isLargeScreen ? 26 : 24} />
                    ),
                }} />
        </Tab.Navigator>
    );
}